import { CIcon } from '~/icons/types'

export const ciRentals: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M15.38 8.898v-2.3a1.2 1.2 0 0 0-1-1.2h-.1a5.963 5.963 0 0 0-1.6 2.6h.3a1.292 1.292 0 0 1 1.2.9 1.31 1.31 0 0 1-.8 1.6c-.31.153-.655.222-1 .2a2.36 2.36 0 0 1-1.6-.7c-1-1-.6-2.8.4-4.5h-2a2.127 2.127 0 0 0-1.5.7l-7.1 7.6a.1.1 0 0 0-.1.1 1.7 1.7 0 0 0 0 1.6l.1.1 5.5 5.7c.2.4.7.4.9.4.307-.028.593-.17.8-.4l7-7.5-.4-1.5a3.276 3.276 0 0 1 1-3.4Z'
    },
    {
      d:
        'm23.68 12.8-.6-2.3a2.82 2.82 0 0 0-3.4-2l-.7.2-.8-3.2v-.2a.9.9 0 0 1-.1-.5l-.1-.4a.1.1 0 0 0-.1-.1 2.25 2.25 0 0 0-.2-2 1.606 1.606 0 0 0-1.1-.5c-1.1 0-2.5.9-3.7 2.2-.324.347-.625.714-.9 1.1-1.1 1.5-1.6 3.2-.8 4a1.107 1.107 0 0 0 1 .5 1.7 1.7 0 0 0 .7-.1.446.446 0 0 0 .3-.6c0-.2-.2-.3-.4-.3h-.2c-.2 0-.3.1-.4.1a.52.52 0 0 1-.4-.2c-.3-.3.1-1.8 1.3-3.3v-.1l.1-.1.3-.3a5.224 5.224 0 0 1 3-1.9.52.52 0 0 1 .4.2c.3.3 0 1.4-.8 2.6v1.5a6.526 6.526 0 0 0 1-1.5l.3 1 .3 1.2.1.5.2.5-.4.1-.2.1a2.913 2.913 0 0 0-2 2.8 1.7 1.7 0 0 0 .1.7l.5 2.1v.2c.077.367.292.689.6.9.1.1.2.1.3.2.213.126.454.195.7.2h.1a.368.368 0 0 0 .3-.1l.5-.1 1.3 5a1.02 1.02 0 0 0 .5.8 1.6 1.6 0 0 0 1.1.5 2.92 2.92 0 0 0 .9-.2 1.506 1.506 0 0 0 .7-1.9l-1.3-5 .8-.2a1.517 1.517 0 0 0 1-.9 1.72 1.72 0 0 0 .2-1.2Zm-1.5 7.6a.67.67 0 0 1-.3.8.468.468 0 0 1-.7-.1.215.215 0 0 0-.2-.2v-.1l-1.3-5 1.2-.4 1.3 5Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'rentals',
  type: 'solid'
}
